var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":"","wrap":"","xs12":"","id":"titleContainer"}},[_c('v-flex',{staticClass:"py-4",attrs:{"xs12":""}},[_c('h1',[_vm._v(_vm._s(_vm.title))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }